import type { Dictionary } from 'shared/legacy/contexts/LocalizationContext/types';

import { IndeedCandidateAlreadyContactedException } from './IndeedCandidateAlreadyContactedException';
import { IndeedCandidateRecentlyDeclinedException } from './IndeedCandidateRecentlyDeclinedException';

export const getIndeedCandidateEngagementErrorMessage = (error: unknown, dictionary: Dictionary) => {
  if (error instanceof IndeedCandidateAlreadyContactedException) {
    return dictionary.indeedCandidateAlreadyContacted;
  }

  if (error instanceof IndeedCandidateRecentlyDeclinedException) {
    return dictionary.indeedCandidateRecentlyDeclined;
  }

  return null;
};
